import styled, { css, keyframes } from 'styled-components';

const fade = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const createDelayStyles = (n, delay) => {
  let styles = '';
  for (let i = 1; i < n; i++) {
    if (i === n - 1) {
      // if we are at the button then we want it to have the same delay as the final message
      styles += `&:nth-of-type(${i + 1}) { animation-delay: ${
        delay * (i - 1)
      }s; }`;
    } else {
      styles += `&:nth-of-type(${i + 1}) { animation-delay: ${delay * i}s; }`;
    }
  }
  return css`
    ${styles}
  `;
};

export const Node = styled.li`
  opacity: 0;
  animation: ${fade} ${({ speed }) => speed}s forwards;
  ${({ length, delay }) => createDelayStyles(length, delay)}
`;

export const List = styled.ul`
  list-style: none;
  padding: 0;
`;
